export default __webpack_public_path__ + "static/media/twitter.42a479fc.svg";